import React, { Component } from "react";
import { Modal } from "antd";
import {ExclamationCircleOutlined} from '@ant-design/icons';
import Script from "react-load-script";
import {isEmpty} from "lodash";

let map;
let markers = [], center
// newList for new markers and markerList for existing markers
class DefineLocation extends Component {
  state = {
    markerList: this.props.markerList,
    newList: [],
    zoom: 8
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    if (nextProps?.markerList) {
      this.setState({markerList: nextProps?.markerList})
    }

    if (nextProps?.zoom && nextProps?.zoom !== this.state.zoom) {
      this.setState({zoom: nextProps?.zoom})
    }
  }

  initAutocomplete = () => {
    this.setInitialValues();

    // Create the search box and link it to the UI element.----------------------------------
    const input = document.getElementById("pac-input");
    const searchBox = new window.google.maps.places.SearchBox(input);
    map.controls[window.google.maps.ControlPosition.TOP_LEFT].push(input);

    searchBox.addListener("places_changed", () => this.onSearchLocation(searchBox));
    //---------------------------------------------------------------------------------------

    // event on bound change
    map.addListener("bounds_changed", () => searchBox.setBounds(map.getBounds()));

    // on map click
    map.addListener("click", (mapsMouseEvent) => this.onMapClick(mapsMouseEvent.latLng.toJSON()))

    // on zoom chaned
    map.addListener("zoom_changed", () => this.setState({zoom: map.getZoom()}) )
  }

  // set initial pins and map and center
  setInitialValues = () => {
    const {quoteDetail,isView} = this.props;
    const {markerList, zoom} = this.state;

    if (markerList.length > 0) {
      center = new window.google.maps.LatLng(markerList?.[0]?.lat, markerList?.[0]?.lng)
    } else if (!isEmpty(quoteDetail?.address?.geo_location)) {
      center = new window.google.maps.LatLng(quoteDetail?.address?.geo_location?.latitude, quoteDetail?.address?.geo_location?.longitude)
    } else {
      center = new window.google.maps.LatLng("41.881832", "-87.623177")
    }
    map = new window.google.maps.Map(document.getElementById("location-map"), {
      center,
      zoom: zoom || 8,
      mapTypeId: "roadmap",
    });

    markers = markerList?.map((obj, index) => {
      let new_marker = new window.google.maps.Marker({
        map: map,
        title: '',
        label:isView?'': `${index + 1}`,
        position: new window.google.maps.LatLng(obj?.lat, obj?.lng),
        draggable: true
      })
      // remove marker
      if(!isView)
      {
        new_marker.addListener("click", () => {
          Modal.confirm({
            title: 'Remove Marker',
            icon: <ExclamationCircleOutlined />,
            content: 'Are you sure?',
            okText: 'Yes',
            cancelText: 'No',
            onOk: () => {
              const {markerList} = this.state;
              markerList.splice(parseInt(new_marker.getLabel()) - 1, 1)
              markers[parseInt(new_marker.getLabel()) - 1].setMap(null)
              this.setState({markerList})
            }
          });
        });
      }

      // drag marker
      window.google.maps.event.addListener(new_marker, 'dragend', (evt) => {
        const {markerList} = this.state;
        markerList[parseInt(new_marker.getLabel()) - 1] = evt.latLng.toJSON()
        this.setState({markerList})
      });
      // new_marker.setMap(map);
      return new_marker
    })
  }

  // on search location
  onSearchLocation = (searchBox) => {
    const places = searchBox.getPlaces();

    if (places.length === 0) {
      return;
    }
    // For each place, get the icon, name and location.
    const bounds = new window.google.maps.LatLngBounds();
    places.forEach((place) => {
      if (!place.geometry) {console.log("Returned place contains no geometry"); return;}
      // Create a marker for each place.
      this.onMapClick(place.geometry.location?.toJSON())

      if (place.geometry.viewport) {
        // Only geocodes have viewport.
        bounds.union(place.geometry.viewport);
      } else {
        bounds.extend(place.geometry.location);
      }
    });

    map.fitBounds(bounds);
  }

  // on map click
  onMapClick = (obj) =>  {
    const {newList} = this.state;
    const {isView} = this.props;
    if(!isView)
    {
      let new_marker = new window.google.maps.Marker({
        map: map,
        title: '',
        label:isView?'': `${markers.length + 1}`,
        position: new window.google.maps.LatLng(obj?.lat, obj?.lng),
        draggable: true
      })
      // remove marker
      new_marker.addListener("click", () => {
        Modal.confirm({
          title: 'Remove Marker',
          icon: <ExclamationCircleOutlined />,
          content: 'Are you sure?',
          okText: 'Yes',
          cancelText: 'No',
          footer: <div><button className="btn btn-brand btn-bdr">Cancel</button><button className="btn btn-warning">Apply</button></div>,
          onOk: () => {
            const {newList} = this.state;
            newList.splice(parseInt(new_marker.getLabel()) - 1, 1)
            markers[parseInt(new_marker.getLabel()) - 1].setMap(null)
            this.setState({newList})
          }
        });
      });
      // drag marker
      window.google.maps.event.addListener(new_marker, 'dragend', (evt) => {
        const {newList} = this.state;
        newList[parseInt(new_marker.getLabel()) - 1] = evt.latLng.toJSON()
        this.setState({newList})
      });
      // new_marker.setMap(map);
      markers.push(new_marker) // contains google map object
      newList.push(obj) // contains only lat lng
      this.setState({newList})
    }
  }

  // on remove all marker
  onRemoveAll = () => {
    for (let i = 0; i < markers.length; i++) {
      markers[i].setMap(null);
    }
    markers = [];
    this.setState({newList: [], markerList: []})
  }

  render() {
    const {isView=false, visible, onCancel, onSave } = this.props
    const {markerList, newList, zoom} = this.state;
    console.warn('markerList', markerList);
    console.warn('newList', newList);
    console.warn('zoom', zoom);
    return (
      <Modal
        title="Locations"
        visible={visible}
        disabled={true}
        className="md-modal"
        onCancel={() => onCancel()}
        footer={[
          <button key="cancel"  className="btn btn-success btn-bdr" onClick={() => onCancel()}>Cancel</button>,
          <button key="remove" hidden={isView} disabled={isView} className="btn btn-danger btn-bdr" onClick={() => this.onRemoveAll()}>Remove All Markers</button>,
          <button key="save" hidden={isView} disabled={isView} className="btn btn-warning" onClick={() => {
            onSave([...markerList, ...newList], zoom)
            onCancel()
          }}>Save</button>
        ]}
      >
        <div id="gmap">
          <Script
            url={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_PLACE_API_KEY}&libraries=places`}
            onLoad={() => window.requestAnimationFrame(this.initAutocomplete)}
          />
          <input
            id="pac-input"
            className="form-control"
            type="text"
            placeholder="Search Box"
          />
          <div id="location-map" name={'location-map'} style={{width: '500px', height: '500px'}}></div>
        </div>
      </Modal>
    );
  }


}

export default DefineLocation;
